export class ProductFilter{
    onlyMy : boolean;
    category : number;
    clientName : string;
    constructor(){
        this.onlyMy = false;
        this.category = 0;
        this.clientName = ""
    }
}